<div class="ipm-campaign-funding-section">
  <div class="custom-form mb-0">
    <div class="row">
      <div class="col-12 p-0">
        <div class="card pt-0 ipm-background-transparent px-0 pb-0">
          <ng-container [formGroup]="topUpForm">
            <label class="parentlbl">
              Add Funds
              <div class="ipm-close-icon" (click)="closePopup()">
                <i class="pi pi-times"></i>
              </div>
            </label>
          <div class="col-12 mb-3">
              <div class="ipm-liquidity-item" [class.is-warning]="currentRequiredAmount > 0">
                  <div class="liq-title"><i class="pi pi-bolt"></i>Available Balance</div>
                  <h4>{{ producerwalletBalance | currency:'INR':'symbol':'1.2-2' }}</h4>
                  <i class="pi pi-wallet liq-watermark"></i>
                  <div class="status-banner warning" *ngIf="currentRequiredAmount > 0">
                    <i class="pi pi-exclamation-circle"></i>
                    <span>Minimum campaign funding not met.</span>
                  </div>
              </div>
            </div>
          <div class="ipm-funding-layout">
                <div class="ipm-funding-details">
                  <article class="funding-card ipm-current-balance">
                    <div class="card-title" [class.is-warning]="currentRequiredAmount > 0"><i class="pi pi-credit-card"></i>
                      {{currentRequiredAmount > 0 ? 'Amount To Be Paid' : 'Top-up Amount'}}
                    </div>
                     <div class="ipm-top-up-section">
                        <div class="topup-body">
                          <div class="preset-grid">
                            <button
                              type="button"
                              *ngFor="let amount of presets"
                              class="preset-btn"
                              [disabled]="currentRequiredAmount > 0 && currentRequiredAmount > amount"
                              [class.active]="selectedPreset === amount"
                              (click)="onPresetSelect(amount)">
                              {{ amount | currency:'INR':'symbol':'1.0-0' }}
                            </button>
                          </div>
                          <p>Enter amount or choose a quick recharge preset.</p>
                          <div class=" form-group custom-form-group">
                              <div class="input-prefix" [class.error-border-color]="topUpForm.controls['topUpAmount'].invalid && topUpForm.controls['topUpAmount'].touched">
                                  <span class="currency-symbol">₹</span>
                                  <input type="text" class="form-control" id="topUpAmount" formControlName="topUpAmount"
                                      (keypress)="formService.keyPressNumber($event)"
                                      (keyup)="!formService.keyPressNumber($event) ? formService.setControlValue(topUpForm.controls['topUpAmount']) : ''"
                                      placeholder="500" min="1">
                              </div>
                              <div class="ipm-error-icon"
                                  *ngIf="topUpForm.controls['topUpAmount'].invalid && topUpForm.controls['topUpAmount'].touched">
                                  <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                              </div>
                              <div class="help-block error-message"
                                  *ngIf="topUpForm.controls['topUpAmount'].invalid && topUpForm.controls['topUpAmount'].touched">
                                  <i class="fa fa-exclamation-triangle"></i>
                                  {{formService.getErrorMessage(topUpForm.controls['topUpAmount']!, 'Amount', 500, 100000)}}
                              </div>
                          </div>
                        </div>
                      </div>
                  </article>
                </div>
                <div class="row">
                  <div class="col-12 padding-unset">
                    <div class="budget-section">
                        <h3>Payment Summary</h3>
                        <div class="budget-rows">
                          <div class="ipm-budget-item">
                            <span class="header">Balance to be added</span>
                            <span class="value">{{topUpForm.controls['topUpAmount'].value  |  currency:'INR'}}</span>
                          </div>
                          <div class="ipm-budget-item" *ngIf="currentTier !== 'tier0'">
                            <span class="header">Discount amount</span>
                            <span>
                                - {{(topUpForm.controls['topUpAmount'].value  * 0.2) |  currency:'INR'}}
                            </span>
                          </div>
                          <div class="ipm-budget-item" *ngIf="currentTier !== 'tier0'">
                            <span class="header">Total amount to be paid</span>
                            <span>
                                {{ (topUpForm.controls['topUpAmount'].value - (topUpForm.controls['topUpAmount'].value * 0.2)) | currency:'INR' }}
                            </span>
                          </div>
                          <!-- <div class="ipm-budget-item">
                            <span class="header">Balance to be added</span>
                            <span>
                                {{ (topUpForm.controls['topUpAmount'].value) | currency:'INR' }}
                            </span>
                          </div> -->
                         </div>
                    </div>
                  </div>
                </div>
          </div>
          <div class="topup-footer">
              <button type="button" class="pay-btn" (click)="orderFundCreated()">
                <i class="pi pi-credit-card"></i>
                Pay Now
              </button>
          </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentSuccessPopup let-data>
    <ipm-payment-success [type]="data.popType"
        [message]="data.message"
        [isShowButton]="true"
        [diwaliCelebration]="false"
        [buttonText]="data?.buttonText">
    </ipm-payment-success>
</ng-template>

<ng-template #billingAddressesTemplate let-data>
    <ipm-billing-address-popup></ipm-billing-address-popup>
</ng-template>
